import KpiCard from '../common/KpiCard';
import useMetric from '../../hooks/useMetric';
import { changePct, formatNumber } from '../../utils/format';

export default function ConversationKpiCard() {
  const { status, data, error, retry } = useMetric('conversations');
  return (
    <KpiCard
      testId="kpi-conversations" title="Total Conversations" icon="bi-chat-dots-fill" tone="primary" to="/conversations"
      status={status} error={error} onRetry={retry} emptyText="No conversations yet."
      value={data && formatNumber(data.value)} delta={data && changePct(data.value, data.previous)}
      sparkline={data?.sparkline} footnote="All channels combined"
    />
  );
}
